import PropTypes from "prop-types";

/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import Banner from "./Banner";

import Style from "ae-style";

import { useResources } from "@aetonix/hooks";

export default function BatteryBanner(props) {
	const {
		localize,
	} = useResources();

	var color;
	var message_line1;

	var banner = props.banner;
	var time = banner.updated_at;
	var date = banner.formatted_date;
	var from = banner.from;

	color = Style.colors.gray;
	message_line1 = localize("banner.batterylow", {
		lname: from.lname,
		fname: from.fname,
	});

	return (
		<Banner
			time={time}
			date={date}
			message_line1={message_line1}
			color={color}
			border
		/>
	);
}
